module.exports = __webpack_public_path__ + "static/bentonsanscond-bold-webfont-1d3b32e9aa1d1366325e89dbf1613942.woff2";